import './NotFound.css'

export default function NotFound() {
  return (
    <div className="not-found">
      <video className="video-player" muted autoPlay playsInline loop>
        <source src="/static/video/not-found.mp4?20230818" type="video/mp4" />
      </video>
      <div className="video-caption">
        <div className="error-code">404</div>
        <h1 className="not-found-title">Page is not found</h1>
        <div className="not-found-description">
          Sorry, the page you’re looking doesn’t exist.
        </div>
      </div>
    </div>
  )
}
